import React from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../../../components/common/PageHeader";
import SearchBar from "../../../../components/common/SearchBar";

/**
 * Product List Header Component
 * Displays the page header with search, create button, and navigation
 */
const ProductListHeader = ({ searchQuery, onSearchChange }) => {
  const navigate = useNavigate();

  return (
    <PageHeader
      showBackButton={true}
      backTo={-1}
      title="Products"
      subtitle={
        <span className="flex items-center gap-2">
          <span className="inline-block w-2 h-2 bg-blue-500 rounded-full"></span>
          Manage your menu items and inventory
        </span>
      }
      action={
        <div className="flex items-center gap-3">
          {/* Bulk Upload Button */}
          <button
            onClick={() => navigate("/product/bulk-upload")}
            className="bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2 shadow-sm hover:shadow-md border border-gray-300"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1M16 12l-4-4m0 0l-4 4m4-4v12"
              />
            </svg>
            Bulk Upload
          </button>

          {/* Create Product Button */}
          <button
            onClick={() => navigate("/product/add")}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2 shadow-sm hover:shadow-md"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
            Create New Product
          </button>
        </div>
      }
      search={
        <SearchBar
          value={searchQuery}
          onChange={onSearchChange}
          placeholder="Search products by name, category, or subcategory..."
          className="max-w-lg"
        />
      }
    />
  );
};

export default ProductListHeader;
